import { render, staticRenderFns } from "./PenerimaanMPR.vue?vue&type=template&id=c8505e94"
import script from "./PenerimaanMPR.vue?vue&type=script&lang=js"
export * from "./PenerimaanMPR.vue?vue&type=script&lang=js"
import style0 from "./PenerimaanMPR.vue?vue&type=style&index=0&id=c8505e94&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports